module.exports = __webpack_public_path__ + "static/img/bgimg5.8c19d25b.png";